import { translate as tr, type Language } from "../shared/i18n";
import { Button } from "./ui/button";

export function LanguageSwitcher({ language, onChange }: { language: Language; onChange: (language: Language) => void }) {
  return <div className="language-switch" role="group" aria-label={tr("Язык")}>{(["ru", "uz"] as const).map((value) => <Button key={value} variant="ghost" size="sm" aria-pressed={value === language} className={value === language ? "active px-1.5" : "px-1.5"} onClick={() => onChange(value)}>{value.toUpperCase()}</Button>)}</div>;
}
